function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import DefaultOptions from './DefaultOptions';
import DisplaySize from './modules/DisplaySize';
import Toolbar from './modules/Toolbar';
import Resize from './modules/Resize';
import Keyboard from './modules/Keyboard';
import _Quill from 'quill';
var Quill = window.Quill || _Quill;
var Parchment = Quill.import('parchment');
var knownModules = {
  DisplaySize: DisplaySize,
  Toolbar: Toolbar,
  Resize: Resize,
  Keyboard: Keyboard
};
/**
 * Custom module for quilljs to allow user to resize elements
 * (Works on Chrome, Edge, Safari and replaces Firefox's native resize behavior)
 * @see https://quilljs.com/blog/building-a-custom-module/
 */

var QuillResize = /*#__PURE__*/function () {
  function QuillResize(quill) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, QuillResize);

    quill.resizer = this; // save the quill reference and options

    this.quill = quill; // Apply the options to our defaults, and stash them for later
    // defaultsDeep doesn't do arrays as you'd expect, so we'll need to apply the classes array from options separately

    var moduleClasses = false;

    if (options.modules) {
      moduleClasses = options.modules.slice();
    } // Apply options to default options


    this.options = Object.assign({}, DefaultOptions, options);
    this.options.styles = Object.assign({}, DefaultOptions.styles, options.styles); // (see above about moduleClasses)

    if (moduleClasses !== false) {
      this.options.modules = moduleClasses;
    } // disable native image resizing on firefox


    document.execCommand('enableObjectResizing', false, 'false'); // respond to clicks inside the editor

    this.quill.root.addEventListener('mousedown', this.handleClick.bind(this), false);
    this.quill.on('text-change', this.handleChange.bind(this));
    this.quill.emitter.on('resize-edit', this.handleEdit.bind(this));
    this.quill.root.parentNode.style.position = this.quill.root.parentNode.style.position || 'relative'; // add class to selected parchment

    this.selectedBlots = [];

    if (this.options.selectedClass) {
      this.quill.on('selection-change', this.addBlotsSelectedClass.bind(this));
    } // setup modules


    this.moduleClasses = this.options.modules;
    this.modules = []; // inject keyboard event

    if (this.options.keyboardSelect) {
      Keyboard.injectInit(this.quill);
    }
  }

  _createClass(QuillResize, [{
    key: "initializeModules",
    value: function initializeModules() {
      var _this = this;

      this.removeModules();
      this.modules = this.moduleClasses.map(function (ModuleClass) {
        return new (knownModules[ModuleClass] || ModuleClass)(_this);
      });
      this.modules.forEach(function (module) {
        module.onCreate();
      });
      this.onUpdate();
    }
  }, {
    key: "onUpdate",
    value: function onUpdate(fromModule) {
      this.updateFromModule = fromModule;
      this.repositionElements();
      this.modules.forEach(function (module) {
        module.onUpdate();
      });
    }
  }, {
    key: "removeModules",
    value: function removeModules() {
      this.modules.forEach(function (module) {
        module.onDestroy();
      });
      this.modules = [];
    }
  }, {
    key: "handleEdit",
    value: function handleEdit() {
      if (!this.blot) return;
      var index = this.blot.offset(this.quill.scroll);
      this.hide();
      this.quill.focus();
      this.quill.setSelection(index, 1);
    }
  }, {
    key: "handleClick",
    value: function handleClick(evt) {
      var show = false;
      var blot;
      var target = evt.target;

      if (target && target.tagName) {
        blot = this.quill.constructor.find(target);

        if (blot) {
          show = this.judgeShow(blot, target);
        }
      }

      if (show) {
        evt.preventDefault(); // evt.stopPropagation()

        return;
      }

      if (this.activeEle) {
        // clicked on a non image
        this.hide();
      }
    }
  }, {
    key: "judgeShow",
    value: function judgeShow(blot, target) {
      var res = false;
      if (!blot) return res;
      if (!target && blot.domNode) target = blot.domNode;
      var options = this.options.parchment[blot.statics.blotName];
      if (!options) return res;
      if (this.activeEle === target) return true;
      var limit = options.limit || {};

      if (!limit.minWidth || limit.minWidth && target.offsetWidth >= limit.minWidth) {
        res = true;

        if (this.activeEle) {
          // we were just focused on another image
          this.hide();
        } // keep track of this img element


        this.activeEle = target;
        this.blot = blot; // clicked on an image inside the editor

        this.show(target);
      }

      return res;
    }
  }, {
    key: "handleChange",
    value: function handleChange(delta, oldDelta, source) {
      if (this.updateFromModule) {
        this.updateFromModule = false;
        return;
      }

      if (source !== 'user' || !this.overlay || !this.activeEle) return;
      this.onUpdate();
    }
  }, {
    key: "show",
    value: function show() {
      this.showOverlay();
      this.initializeModules();
      if (this.options.activeClass) this.activeEle.classList.add(this.options.activeClass);
    }
  }, {
    key: "showOverlay",
    value: function showOverlay() {
      var _this2 = this;

      if (this.overlay) {
        this.hideOverlay();
      }

      this.quill.setSelection(null); // prevent spurious text selection

      this.setUserSelect('none'); // Create and add the overlay

      this.overlay = document.createElement('div'); // this.overlay.setAttribute('title', "Double-click to select image");

      Object.assign(this.overlay.style, this.options.styles.overlay);
      this.overlay.addEventListener('dblclick', this.handleEdit.bind(this), false);
      this.quill.root.parentNode.appendChild(this.overlay);

      this.hideProxy = function (evt) {
        if (!_this2.activeEle) return;

        _this2.hide();
      }; // listen for the image being deleted or moved


      this.quill.root.addEventListener('input', this.hideProxy, true);
      this.updateOverlayPositionProxy = this.updateOverlayPosition.bind(this);
      this.quill.root.addEventListener('scroll', this.updateOverlayPositionProxy);
      this.repositionElements();
    }
  }, {
    key: "hideOverlay",
    value: function hideOverlay() {
      if (!this.overlay) {
        return;
      } // Remove the overlay


      this.quill.root.parentNode.removeChild(this.overlay);
      this.overlay = undefined; // stop listening for image deletion or movement

      document.removeEventListener('keydown', this.keyboardProxy, true);
      this.quill.root.removeEventListener('input', this.hideProxy, true);
      this.quill.root.removeEventListener('scroll', this.updateOverlayPositionProxy); // reset user-select

      this.setUserSelect('');
    }
  }, {
    key: "repositionElements",
    value: function repositionElements() {
      if (!this.overlay || !this.activeEle) {
        return;
      } // position the overlay over the image


      var parent = this.quill.root.parentNode;
      var eleRect = this.activeEle.getBoundingClientRect();
      var containerRect = parent.getBoundingClientRect();
      Object.assign(this.overlay.style, {
        left: "".concat(eleRect.left - containerRect.left - 1 + parent.scrollLeft, "px"),
        top: "".concat(eleRect.top - containerRect.top + this.quill.root.scrollTop, "px"),
        width: "".concat(eleRect.width, "px"),
        height: "".concat(eleRect.height, "px"),
        marginTop: -1 * this.quill.root.scrollTop + 'px'
      });
    }
  }, {
    key: "updateOverlayPosition",
    value: function updateOverlayPosition() {
      this.overlay.style.marginTop = -1 * this.quill.root.scrollTop + 'px';
    }
  }, {
    key: "addBlotsSelectedClass",
    value: function addBlotsSelectedClass(range, oldRange) {
      var _this3 = this;

      if (!range) {
        this.removeBlotsSelectedClass();
        this.selectedBlots = [];
        return;
      }

      var leaves = this.quill.scroll.descendants(Parchment.Leaf, range.index, range.length);
      var blots = leaves.filter(function (blot) {
        var canBeHandle = !!_this3.options.parchment[blot.statics.blotName];
        if (canBeHandle) blot.domNode.classList.add(_this3.options.selectedClass);
        return canBeHandle;
      });
      this.removeBlotsSelectedClass(blots);
      this.selectedBlots = blots;
    }
  }, {
    key: "removeBlotsSelectedClass",
    value: function removeBlotsSelectedClass() {
      var _this4 = this;

      var ignoreBlots = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      if (!Array.isArray(ignoreBlots)) ignoreBlots = [ignoreBlots];
      this.selectedBlots.forEach(function (blot) {
        if (ignoreBlots.indexOf(blot) === -1) {
          blot.domNode.classList.remove(_this4.options.selectedClass);
        }
      });
    }
  }, {
    key: "hide",
    value: function hide() {
      this.hideOverlay();
      this.removeModules();
      if (this.activeEle && this.options.activeClass) this.activeEle.classList.remove(this.options.activeClass);
      this.activeEle = undefined;
      this.blot = undefined;
    }
  }, {
    key: "setUserSelect",
    value: function setUserSelect(value) {
      var _this5 = this;

      ['userSelect', 'mozUserSelect', 'webkitUserSelect', 'msUserSelect'].forEach(function (prop) {
        // set on contenteditable element and <html>
        _this5.quill.root.style[prop] = value;
        document.documentElement.style[prop] = value;
      });
    }
  }]);

  return QuillResize;
}();

export { QuillResize as default };

if (window.Quill) {
  window.Quill.register('modules/resize', QuillResize);
}